import styles from './MyTransferPage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import MainNav from '../components/main-nav/MainNav';
import { Transfer } from '../common/transfer/Transfer';
import { CancelRemittance } from './components/CancelRemittance';
import { Transcations } from './components/Transcations';
import { transcationActions, commonActions, ratesActions } from '../../stores/_actions';
import { Pagination } from 'semantic-ui-react';
import { NoRecord } from 'views/common/norecord/norecord';

function MyTransferPage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      Refno: '',
      FromDate: '01/Jan/1950',
      ToDate: '01/Jan/2099',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(transcationActions.transcationList(payload));
    dispatch(commonActions.getCustDetailsByCode(payload));
    dispatch(ratesActions.clearRatesData());
    dispatch(transcationActions.clearTransInfo());
  }, []);
  const userProfile = useSelector((state) => state.getCustDetails.data);

  // const [setList, setListData] = useState();
  let transcationListData;
  let status;
  useSelector((state) => {
    transcationListData = state.transcation?.data;
    status = state.transcation.transcation;
    // setTimeout(() => {
    //   setListData((setList) => (setList = transcationListData));
    // }, 1000);
  }, []);

  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: 6,
  });
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage });
  };
  const itemsPerPage = 6;
  const { page } = pager;
  const totalPages = Math.ceil(transcationListData && transcationListData.length / itemsPerPage) || 1;
  const items = transcationListData && transcationListData.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.beneficiary}>
                <div className={styles.beneficiary__item}>
                  {transcationListData ? <Transcations list={items} styles={styles} /> : <NoRecord status={status} />}
                </div>
              </div>
              {transcationListData ? (
                <div className={styles.pageCount}>
                  <div className={styles.pageCountcont}>
                    <span>{page}</span> / <span>{totalPages}</span>
                  </div>
                  <div className={styles.carousal}>
                    <Pagination
                      boundaryRange={0}
                      defaultActivePage={page}
                      ellipsisItem={null}
                      firstItem={null}
                      lastItem={null}
                      siblingRange={null}
                      totalPages={totalPages}
                      onPageChange={setPageNum}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className={styles.pageRight}>
              <Transfer />
              <div>&nbsp; &nbsp;</div>
              <CancelRemittance />
            </div>
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { MyTransferPage };
